import { Anchor } from "../ui/anchor";

export function detailAnchor(param?: { href?: string }) {
  return function (
    _ButtonWithModal: React.JSX.Element,
    _ButtonWithAction: React.JSX.Element,
    row: { [key: string]: unknown },
  ) {
    const { href } = param ?? {};
    return (
      <Anchor mood="axiata-blue-link" href={href ?? `./${row.id}`}>
        Detail
      </Anchor>
    );
  };
}
